import { request } from "./requests";

const SERVICE = "/subscription/api/v1";

export const insert = (requestBody) => {
  return request.post(SERVICE + "/insert", {
    ...requestBody,
  });
};
